import { render } from "./DataMapperInvocationAdmin.vue?vue&type=template&id=f6c4c8aa&scoped=true"
import script from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocationAdmin.vue?vue&type=script&lang=js"

import "./DataMapperInvocationAdmin.vue?vue&type=style&index=0&id=f6c4c8aa&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c4c8aa"]])

export default __exports__